import {
    RetailModePricingTierEditingModel,
    RetailModePricingTierModel,
    RetailModeSettingsEditingModel,
    RetailModeSettingsModel,
} from "@store/Types/RetailModeSettings";

export const emptyTierPricing: RetailModePricingTierEditingModel = {
    id: 0,
    from: "0",
    to: "0",
    priceIncreasePercent: "0",
};

export const mapRetailModeSettingsToEditing = (retailModeSettings: RetailModeSettingsModel) => {
    if (retailModeSettings !== undefined) {
        return {
            ...retailModeSettings,
            priceIncreasePercent: retailModeSettings.priceIncreasePercent.toString(),
            pricingTiers: retailModeSettings.pricingTiers?.map((tier, index) => ({
                ...tier,
                id: index,
                from: tier.from.toString(),
                to: tier.to.toString(),
                priceIncreasePercent: tier.priceIncreasePercent.toString(),
            })) || [emptyTierPricing],
        } as RetailModeSettingsEditingModel;
    }
};

export const mapEditingToRetailModeSettings = (retailModeSettingsEditing: RetailModeSettingsEditingModel) =>
    ({
        ...retailModeSettingsEditing,
        priceIncreasePercent: Number(retailModeSettingsEditing.priceIncreasePercent),
        pricingTiers: retailModeSettingsEditing.pricingTiers.map(
            tier =>
                ({
                    ...tier,
                    priceIncreasePercent: Number(tier.priceIncreasePercent),
                    from: Number(tier.from),
                    to: Number(tier.to),
                } as RetailModePricingTierModel),
        ),
    } as RetailModeSettingsModel);
